// extracted by mini-css-extract-plugin
export default {"canvas":"CanvasBackground_canvas__GqYsD"};